<template>
  <div v-if="canShow" class="card mb-4">
    <div class="card-body py-3 bg-highlight">
      <i v-if="isClose" @click="closeInviteRequest()" class="fa fa-close close-dialog t-red" ></i>
      <div class="mb-0 add-organisation block-fa-span">
        <i class="fa fa-warning t-yellow t-sm pr-1 mt-1"></i>
        <p class="mb-0 t-sm t-regular d-block block-span">
          You have invitations waiting for you! <router-link :to="{ name: 'researcher.invite', params: { id: $currentUser.slug_values[0] } }">Manage your invitations here.</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pendingInviteRequest',
  props: {
    isClose: {
      type: Boolean,
      default: false
    },
    checkCookie: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      canShow: false
    }
  },
  created () {
    this.checkShow()
  },
  watch: {
    'user.pending_invites_count' (newVal, oldVal) {
      if (newVal !== oldVal) this.checkShow()
    }
  },
  methods: {
    checkShow () {
      if (this.$can.edit('researcher', this.user.rw_access)) {
        if (this.checkCookie) {
          ((!this.$ls.getAccountData() || !this.$ls.getAccountData().inviteRequestClosed) && this.user.pending_invites_count > 0)
            ? this.canShow = true
            : this.canShow = false
        } else {
          this.canShow = this.user.pending_invites_count
        }
      }
    },
    closeInviteRequest () {
      let orgRequest = false
      if (this.$ls.getAccountData() && this.$ls.getAccountData().organisationRequestClosed) orgRequest = true
      this.canShow = false
      this.setAccountData(orgRequest)
    },
    setAccountData (orgRequest) {
      let data = this.$ls.getAccountData()
      data.organisationRequestClosed = orgRequest
      data.inviteRequestClosed = true
      this.$ls.setAccountData(data)
    }
  }
}
</script>
